module.exports = __webpack_public_path__ + "static/media/coxinhacostela.6b3248e5.webp";